import { Immutable } from "immer";
import React from "react";
import SVG from "react-inlinesvg";
import { CartReferenceNumber } from "tsi-common-react/src/apps/checkout/CartReferenceNumber";
import { jt, t } from "ttag";

import { templates } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import logo from "../../assets/svg/tempur-toppers-logo.svg";

import siteNavStyles from "../../styles/composable/site-nav.module.scss";
import styles from "./index.module.scss";

type IProps = Immutable<templates.CheckoutHeaderTemplate>;

export const CheckoutHeader = (props: IProps): React.JSX.Element => {
    const secure = (
        <span
            key="secure"
            className={styles.checkoutHeaderHeaderBold}
        >{t`secure`}</span>
    );
    const secureCheckout = jt`${secure} checkout`;

    return (
        <header className="l-full-width">
            <nav
                className={concatClassNames([
                    siteNavStyles.siteNav,
                    styles.checkoutHeader,
                    "site-nav",
                    "checkout-header",
                ])}
            >
                <div
                    className={concatClassNames([
                        siteNavStyles.siteNavContent,
                        styles.checkoutHeaderContent,
                        "l-capped-width",
                    ])}
                >
                    <a
                        className={siteNavStyles.siteNavLogoLink}
                        href={props.root_page_url}
                    >
                        <SVG
                            className={concatClassNames([
                                siteNavStyles.siteNavLogo,
                                siteNavStyles.siteNavLogoCheckout,
                            ])}
                            src={logo}
                        />
                    </a>
                    <a
                        className={concatClassNames([
                            siteNavStyles.siteNavLogoLink,
                            siteNavStyles.siteNavLogoLinkMobile,
                        ])}
                        href={props.root_page_url}
                    >
                        <SVG
                            className={siteNavStyles.siteNavLogoMobile}
                            src={logo}
                        />
                    </a>

                    <h1 className={styles.checkoutHeaderHeader}>
                        {secureCheckout}
                    </h1>

                    <div className={styles.checkoutHeaderHeaderCartRef}>
                        <CartReferenceNumber
                            encodedBasketID={props.encoded_basket_id}
                            phoneNumber={props.support_website_phone_number}
                        />
                    </div>
                </div>
            </nav>
        </header>
    );
};
